import { createSlice, nanoid, PayloadAction } from '@reduxjs/toolkit';

export type AppNotice = {
  id: string;
  message?: string;
};

const MAX_NOTICES = 3;

const noticesSlice = createSlice({
  name: 'notices',
  initialState: [] as AppNotice[],
  reducers: {
    pushNotice: {
      reducer(state, action: PayloadAction<AppNotice>) {
        state.push(action.payload);
        if (state.length > MAX_NOTICES) {
          state.splice(0, state.length - MAX_NOTICES);
        }
      },
      prepare(message?: string) {
        return {
          payload: {
            id: nanoid(),
            message,
          },
        };
      },
    },
    dismissNotice(state, action: PayloadAction<string>) {
      return state.filter(notice => notice.id !== action.payload);
    },
  },
});

export const {
  dismissNotice,
  pushNotice,
} = noticesSlice.actions;

export default noticesSlice.reducer;
